import VueI18n from 'vue-i18n'
import Vue from 'vue'
import { cp, http } from './'

import Locale from './locale'

Vue.use(VueI18n);
const transports = {cp, http};

export default class i18n{
  constructor(){
    this.locale = new Locale('en_US');
    this.locales = [new Locale('en_US')];
    this.fallback = this.locales[0];
    this.config = {};

    this.messages = {};
    this.messages[this.locale.toISOCountryCode()] = {};
    
    this.i18n = null;
    Vue.prototype.$locale = new Locale('en_US');
    Vue.prototype.$date = this.formatDate;
  }

  load(){
    return new Promise((resolve, reject) => {
      http.get(`/statics/lang/${this.locale.toISOCountryCode()}.json`)
      .then(response => {
        let ret = Object.assign({}, this.messages[this.locale.toISOCountryCode()])
        ret = Object.assign({}, response.data);
        this.messages[this.locale.toISOCountryCode()] = ret;
        
        resolve();
      })
    })
  }

  init(){
    this.i18n = new VueI18n({
      locale: this.locale.toISOCountryCode(),
      fallbackLocale: this.fallback.toISOCountryCode(),
      messages: this.messages
    });
    
  }

  setLocale(value){
    const v = new Locale(value);
    this.i18n.locale = v.toISOCountryCode();

    let k = Object.keys(transports);
    k.forEach(t => {
      transports[t].defaults.headers.common['Accept-Language'] = v.toISO3166();
    })
    document.querySelector('html').setAttribute('lang', v.toISOCountryCode());
  }

  setConfig(value) {
    this.config = Object.assign({}, this.config);
    this.config = Object.assign(this.config, value);

    // DateTime
    if (value.datetime){
      value.datetime.forEach(({iso, ...formats}) => {
        const v = new Locale(iso);
        this.i18n.setDateTimeFormat(v.toISOCountryCode(), formats);
      });
    }

    // Number
    if (value.number){
      value.number.forEach(({iso, ...formats}) => {
        const v = new Locale(iso);
        this.i18n.setNumberFormat(v.toISOCountryCode(), formats);
      })
    }

    // fallback
    if (value.fallback_language){
      const v = new Locale(value.fallback_language);
      this.i18n.fallbackLocale = this.fallback = v.toISOCountryCode();
    }

    // languages
    this.locales = value.languages.map(l => new Locale(l));
    // this.i18n.availableLocales = value.languages;

    // messages
    if (value.messages){
      value.messages.forEach(({iso, messages: m}) => {
        //iso = this.formatiso(iso);
        const v = new Locale(iso)
        if (!this.messages.hasOwnProperty(v.toISOCountryCode())){
          this.messages[v.toISOCountryCode()] = {};
        }

        this.messages[v.toISOCountryCode()] = { ...this.messages[v.toISOCountryCode()], ...m };
        this.i18n.setLocaleMessage(v.toISOCountryCode(), this.messages[v.toISOCountryCode()]);
      });
    }
  }

  formatiso(iso){
    return iso.substr(0, 2);
  }

  formatDate(value, format){
    let opts = {
      "year": "numeric",
      "month": "numeric",
      "day": "numeric",
      "hour": "numeric",
      "minute": "numeric",
      "hour12": false
    }

    return new Intl.DateTimeFormat('en_US', opts).format(value);
  }
}
